import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Card, CardContent } from '../components/ui/card';
import { ScrollText, Shield, Award, Heart, HandshakeIcon } from 'lucide-react';

export default function VendorCovenantPage() {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      <main className="flex-1 max-w-3xl mx-auto px-6 md:px-12 py-12 w-full">
        <div className="text-center mb-10">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-primary/10 mb-4">
            <ScrollText className="h-7 w-7 text-primary" />
          </div>
          <h1 className="text-3xl md:text-4xl font-heading font-semibold tracking-tight">
            Christ Kingdom Global Marketplace
          </h1>
          <h2 className="text-xl md:text-2xl text-muted-foreground font-heading mt-2">
            Partnership Covenant &amp; Code of Honor
          </h2>
        </div>

        <Card className="border-primary/10">
          <CardContent className="p-6 md:p-10 space-y-8 leading-relaxed text-foreground">
            <section>
              <p className="text-base md:text-lg">
                <strong>Purpose:</strong> This Covenant establishes a sacred and professional partnership between the
                Christ Kingdom Global Marketplace (the &quot;Marketplace&quot;) and the undersigned Vendor.
                Together, we agree to build a marketplace that reflects the excellence, integrity, and generosity of
                the Kingdom of God.
              </p>
            </section>

            <hr className="border-primary/20" />

            <section>
              <h3 className="text-lg md:text-xl font-heading font-semibold mb-3 flex items-center gap-2">
                <HandshakeIcon className="h-5 w-5 text-primary" />
                1. The Marketplace Commitments — Our Promise to You
              </h3>
              <p className="mb-3">As your partner in economic growth and ministry, the Marketplace covenants to provide:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>
                  <strong>Platform Excellence:</strong> A secure, high-performing digital infrastructure designed to
                  optimize user experience and showcase your brand professionally.
                </li>
                <li>
                  <strong>Targeted Visibility:</strong> Aggressive and intentional marketing strategies to connect your
                  brand with an aligned, values-driven consumer base.
                </li>
                <li>
                  <strong>Spiritual &amp; Professional Cover:</strong> Access to exclusive masterclasses, networking
                  opportunities, and a dedicated prayer network supporting your business growth.
                </li>
              </ul>
            </section>

            <section>
              <h3 className="text-lg md:text-xl font-heading font-semibold mb-3 flex items-center gap-2">
                <Shield className="h-5 w-5 text-primary" />
                2. The Vendor Commitments — Your Promise to the Community
              </h3>
              <p className="mb-3">As an ambassador of Christ within this marketplace, the Vendor covenants to uphold:</p>
              <ul className="list-disc pl-6 space-y-3">
                <li>
                  <strong>The Standard of Excellence:</strong> Delivering high-quality products or services that match
                  or exceed secular market standards. <em>(Colossians 3:23)</em>
                </li>
                <li>
                  <strong>The Standard of Integrity:</strong> Honesty in all marketing claims, transparent pricing, and
                  zero deceptive practices. If errors occur in fulfillment, they will be rectified swiftly and with
                  grace. <em>(Proverbs 11:1)</em>
                </li>
                <li>
                  <strong>The Standard of Honor:</strong> Cultivating peaceful, encouraging, and collaborative
                  relationships with fellow marketplace vendors, avoiding malicious competition or gossip.
                </li>
              </ul>
            </section>

            <section>
              <h3 className="text-lg md:text-xl font-heading font-semibold mb-3 flex items-center gap-2">
                <Award className="h-5 w-5 text-primary" />
                3. Operational Terms &amp; Accountability
              </h3>
              <ul className="list-disc pl-6 space-y-3">
                <li>
                  <strong>Compliance:</strong> The Vendor agrees to maintain all necessary local, state, and federal
                  business licenses and tax registrations.
                </li>
                <li>
                  <strong>Accountability and Restitution:</strong> If a vendor receives consistent negative feedback
                  regarding product quality, deceptive practices, or unreliability, the Marketplace reserves the right
                  to initiate a restoration process. If resolution cannot be reached, the partnership may be dissolved
                  to protect the integrity of the wider community.
                </li>
              </ul>
            </section>

            <section>
              <h3 className="text-lg md:text-xl font-heading font-semibold mb-3 flex items-center gap-2">
                <Heart className="h-5 w-5 text-primary" />
                4. Covenant Agreement
              </h3>
              <p>
                By submitting a vendor application and being accepted into Christ Kingdom Global Marketplace, both
                parties acknowledge that this relationship is more than a commercial agreement; it is a collaborative
                alignment to advance Kingdom principles through economic stewardship.
              </p>
            </section>

            <hr className="border-primary/20" />

            <div className="text-center pt-2">
              <Link
                to="/vendor/apply"
                className="inline-block bg-primary text-primary-foreground px-6 py-3 rounded-full font-medium hover:bg-primary/90 transition-colors"
                data-testid="covenant-apply-cta"
              >
                Apply to Become a Vendor →
              </Link>
              <p className="text-xs text-muted-foreground mt-3">
                Acceptance into the Marketplace constitutes your agreement to this Covenant.
              </p>
            </div>
          </CardContent>
        </Card>
      </main>
      <Footer />
    </div>
  );
}
